<template>
  <v-app-bar
    class="blue accent-3"
    dense
    style="margin-bottom:20px;"
    v-if="!guardian"
  >

    <v-btn fab x-small @click="$router.go(-1)">
      <v-icon>navigate_before</v-icon>
    </v-btn>

    <v-spacer class="desktop"></v-spacer>

    <router-link
      :to="{
        name: 'ClientInfo',
        params: { clientID: clientID },
      }"
    >
      <v-btn
        color="transparent"
        class="ma-1 desktop white--text"
        small
        depressed
        >Dashboard</v-btn
      >
    </router-link>

    <v-menu offset-y open-on-hover>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="transparent"
          v-bind="attrs"
          v-on="on"
          class="ma-1 desktop white--text"
          small
          depressed
          v-if="showOnboardInfo"
        >
          Medical
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="medication in medications"
          :key="medication.title"
          router
          :to="{
            name: medication.name,
            params: { clientID: clientID, page: 'mar' },
          }"
        >
          <v-list-item-title>{{ medication.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-menu offset-y open-on-hover>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="transparent"
          v-bind="attrs"
          v-on="on"
          class="ma-1 desktop white--text"
          small
          depressed
          v-if="showOnboardInfo"
        >
          Onboard Info
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="onboard in onboards"
          :key="onboard.title"
          router
          :to="{
            name: onboard.name,
            params: { clientID: clientID },
          }"
        >
          <v-list-item-title>{{ onboard.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-menu offset-y open-on-hover>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="transparent"
          v-bind="attrs"
          v-on="on"
          class="ma-1 desktop white--text"
          small
          depressed
        >
          Reporting
        </v-btn>
      </template>
      <v-list>
        <template v-for="individual in individuals">
          <template
            v-if="
              (individual.title === 'DOR' && clientState === 'Utah') ||
                (individual.title === 'RAD' && clientState === 'Utah')
            "
          >
          </template>

          <template v-else>
            <v-list-item
              :key="individual.title"
              router
              :to="{
                name: individual.name,
                params: { clientID: clientID },
              }"
            >
              <v-list-item-title>
                {{ individual.title }}
              </v-list-item-title>
            </v-list-item>
          </template>
        </template>
      </v-list>
    </v-menu>

    <v-menu offset-y open-on-hover>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="transparent"
          v-bind="attrs"
          v-on="on"
          class="ma-1 desktop white--text"
          small
          depressed
        >
          Service Plan/ADL's
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="service in services"
          :key="service.title"
          router
          :to="{
            name: service.name,
            params: { clientID: clientID },
          }"
        >
          <v-list-item-title>{{ service.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <!-- <v-menu offset-y open-on-hover>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="transparent"
          v-bind="attrs"
          v-on="on"
          class="ma-1 desktop white--text"
          small
          depressed
        >
          JDT
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="jdt in jdts"
          :key="jdt.title"
          router
          :to="{
            name: jdt.name,
            params: { clientID: clientID },
          }"
        >
          <v-list-item-title>{{ jdt.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu> -->

    <!-- <v-menu offset-y open-on-hover v-if="userState ==='Nevada'">
      <template v-slot:activator="{ on, attrs }">
          <v-btn
              color="transparent"
              v-bind="attrs"
              v-on="on"
              class="ma-1 desktop white--text"
              small
              depressed
          >
              Tracking Sheets
          </v-btn>
      </template>
      <v-list>
          <v-list-item
              v-for="tracking in trackingSheets"
              :key="tracking.title"
              router :to="{name: tracking.route, params: { clientID: clientID }}"
          >
              <v-list-item-title>{{ tracking.title }}</v-list-item-title>
          </v-list-item>
      </v-list>
    </v-menu> -->

    <v-menu offset-y open-on-hover>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="transparent"
          v-bind="attrs"
          v-on="on"
          class="ma-1 desktop white--text"
          small
          depressed
          v-if="!directCareStaff"
        >
          Document Library
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="doc in documents"
          :key="doc.title"
          router
          :to="{
            name: doc.name,
            params: { clientID: clientID },
          }"
        >
          <v-list-item-title>{{ doc.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-spacer></v-spacer>

    <v-menu offset-y close-on-content-click="">
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" class="ma-1 mobile" small depressed>
          Client Menu
        </v-btn>
      </template>

      <v-list mandatory>
        <v-list-group
          prepend-icon="mdi-account-circle"
          @click.stop.prevent
          v-if="medCertified"
        >
          <template v-slot:activator>
            <v-list-item-title>Medical</v-list-item-title>
          </template>

          <v-list-item
            v-for="medication in medications"
            :key="medication.title"
            router
            :to="{
              name: medication.name,
              params: { clientID: clientID, page: 'mar' },
            }"
          >
            <v-list-item-title>{{ medication.title }}</v-list-item-title>

            <v-list-item-icon>
              <v-icon v-text="icon"></v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list-group>

        <v-list-group
          prepend-icon="mdi-account-circle"
          @click.stop.prevent
          v-if="showOnboardInfo"
        >
          <template v-slot:activator>
            <v-list-item-title>Onboard Info</v-list-item-title>
          </template>

          <v-list-item
            v-for="onboard in onboards"
            :key="onboard.title"
            router
            :to="{
              name: onboard.name,
              params: { clientID: clientID },
            }"
          >
            <v-list-item-title>{{ onboard.title }}</v-list-item-title>

            <v-list-item-icon>
              <v-icon v-text="icon"></v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list-group>

        <v-list-group prepend-icon="mdi-account-circle" @click.stop.prevent>
          <template v-slot:activator>
            <v-list-item-title>Reporting</v-list-item-title>
          </template>

          <v-list-item
            v-for="individual in individuals"
            :key="individual.title"
            router
            :to="{
              name: individual.name,
              params: { clientID: clientID },
            }"
          >
            <v-list-item-title>{{ individual.title }}</v-list-item-title>

            <v-list-item-icon>
              <v-icon v-text="icon"></v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list-group>

        <v-list-group prepend-icon="mdi-account-circle" @click.stop.prevent>
          <template v-slot:activator>
            <v-list-item-title>Service Plan/ADL'S</v-list-item-title>
          </template>

          <v-list-item
            v-for="service in services"
            :key="service.title"
            router
            :to="{
              name: service.name,
              params: { clientID: clientID },
            }"
          >
            <v-list-item-title>{{ service.title }}</v-list-item-title>

            <v-list-item-icon>
              <v-icon v-text="icon"></v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list-group>

        <v-list-group prepend-icon="mdi-account-circle" @click.stop.prevent>
          <template v-slot:activator>
            <v-list-item-title>Document Library</v-list-item-title>
          </template>

          <v-list-item
            v-for="doc in documents"
            :key="doc.title"
            router
            :to="{
              name: doc.name,
              params: { clientID: clientID },
            }"
          >
            <v-list-item-title>{{ doc.title }}</v-list-item-title>

            <v-list-item-icon>
              <v-icon v-text="icon"></v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-menu>

    <v-spacer class="mobile"></v-spacer>
  </v-app-bar>
</template>
<script>
import axios from "axios";
const url = require("@/client_config/config").url;
import { mapActions, mapState } from "vuex";
export default {
  props: {
    clientState: String,
    navigateTo: {
      type: String,
      default: 'ClientInfo'
    }
  },
  data: () => ({
    icon: "",
    clients: [],
    clientID: null,
    medApproved: false,
    guardian: false,
    medications: [
      { title: "Medications", icon: "medicine", name: "Medications" },
      { title: "MAR", icon: "medicine", name: "MAR" },
      { title: "Medical Visit Form", icon: "medicine", name: "MedVisit" },
      {
        title: "Medication Inventory",
        icon: "medicine",
        name: "MedicationInventory",
      },
      { title: "Medication Hand Off", icon: "medicine", name: "MedHandOff" },
      // {
      //   title: "Medication Change",
      //   icon: "medicine",
      //   name: "Medication Change",
      // },
      // {
      //   title: "CS Medication",
      //   icon: "medicine",
      //   name: "CS Medication",
      // },
    ],
    onboards: [
      { title: "Medical History", icon: "medicine", name: "Assessments" },
      // { title: 'Agreements/Consents', icon: 'medicine', route: '/consents' }, NOTE: Temporarily Hide this Route
      { title: "Annual Documents", icon: "medicine", name: "AnnualDocs" },
      { title: "Contact Info", icon: "medicine", name: "ContactInfo" },
      { title: "Service Codes", icon: "medicine", name: "ServiceCodes" },
      { title: "Diagnoses", icon: "medicine", name: "Diagnoses" },
      { title: "Behaviors", icon: "medicine", name: "Behaviors" },
      { title: "Allergies", icon: "medicine", name: "Allergies" },
      { title: "Warnings", icon: "medicine", name: "Warning" },
      { title: "Adaptive Equipment", icon: "medicine", name: "Adaptive Equipment" },
      { title: "Discharge Checklist", icon: "medicine", name: "Client Discharge" },
      { title: "Move Checklist", icon: "medicine", name: "Client Move" },
      { title: "Providers", icon: "medicine", name: "Providers" },
    ],
    individuals: [
      { title: "Client Summary", icon: "medicine", name: "Client Summary" },
      { title: "Investigations", icon: "medicine", name: "Investigations" },
      { title: "Attendance", icon: "medicine", name: "Attendance" },
      { title: "Behavior Report", icon: "medicine", name: "BehaviorReport" },
      { title: "Human Rights Restrictions", icon: "medicine", name: "Rights" },
      { title: "Upcoming Events", icon: "medicine", name: "Events" },
      { title: "Inventory", icon: "medicine", name: "Inventory" },
      { title: "Finance", icon: "medicine", name: "Finances" },
      { title: "Fire Drill", icon: "medicine", name: "FireDrill" },
      { title: "Incident Reports", icon: "medicine", name: "Incidents" },
      { title: "Weekly Summary", icon: "medicine", name: "WeeklySummary" },
      { title: "Monthly Summary", icon: "medicine", name: "MonthlySummaries" },
      { title: "Off-Site Visit", icon: "medicine", name: "OffSiteVisit" },
      // {
      //   title: "Quarterly Summary",
      //   icon: "medicine",
      //   name: "QuarterlySummaries",
      // },
      { title: "Menu", icon: "medicine", name: "Meals" },
      // { title: 'RAD', icon: 'medicine', route: '/RAD' }, NOTE: Temporarily Hide this Route
      // { title: 'DOR', icon: 'medicine', route: '/DOR' },
    ],
    services: [
      { title: "Service Plan", icon: "medicine", name: "ServicePlan" },
      { title: "ADL Charting", icon: "medicine", name: "ADL" },
      { title: "Support Strategies", icon: "medicine", name: "Support" },
      { title: "Bowel Movement", icon: "medicine", name: "BMC" },
      { title: "Fluid Tracking", icon: "medicine", name: "FluidTracking" },
      { title: "Seizure Tracking", icon: "medicine", name: "Seizure Tracking" },
    ],

    caseManagements: [
      { title: "Case Management", icon: "medicine", name: "Case Management" },
      { title: "Ancillary", icon: "medicine", name: "Ancillary" },
      { title: "Service Log", icon: "medicine", name: "Service Log" },

    ],

    jdts: [
      { title: "Ancillary Logs", icon: "medicine", name: "AnciallaryLogs" },
      { title: "Case Management", icon: "medicine", name: "Case Management" },
      { title: "Attendance", icon: "medicine", name: "Attendance" },
    ],

    nevadaService: { title: "ADL Charting", icon: "medicine", name: "ADL" },

    documents: [{ title: "View Library", name: "DocumentLibraryClient" }],

    trackingSheets: [
      {title: 'RRS Log (24 Hours)', route: 'RSS Logs'},
      {title: 'RSS Support Logs (Interminate) ', route: 'RSS Support Logs'},
      {title: 'JDT Service Quarterly Progress Report ', route: 'JDT Progress Report'},
      {title: 'JDT Attendance Logs ', route: 'JDT Attendance Logs'},
      {title: 'SLA Service Quarterly Progress Report ', route: 'SLA Progress Report'},
      {title: 'Supplemental Residential Support ', route: 'Support Services'},
    ],

    infos: [
      { title: "Edit Client Info", icon: "medicine", route: "/" },
      { title: "ADL Charting", icon: "medicine", route: "/adl" },
    ],

    admins: [
      ["Management", "people_outline"],
      ["Settings", "settings"],
    ],
    cruds: [
      ["Create", "add"],
      ["Read", "insert_drive_file"],
      ["Update", "update"],
      ["Delete", "delete"],
    ],
    administration: false,
    directCareStaff: false,
    shiftLead: false,
    assistantManager: false,
    houseManager: false,
    programManager: false,
    humanResources: false,
    clientServicesManager: false,
    programCoordinator: false,
    medicalManager: false,
    executiveDirector: false,
    financeManager: false,
    complianceManager: false,
    parentGuardian: false,
    supportCoordinator: false,
    client: false,
    userState: localStorage.getItem("userState"),
  }),

  computed: {
    ...mapState("users", ["user"]),
    showOnboardInfo() {
      if (this.administration) {
        return this.administration;
      } else if (this.programManager) {
        return this.programManager;
      } else if (this.programCoordinator) {
        return this.programCoordinator;
      } else if (this.clientServicesManager) {
        return this.clientServicesManager;
      } else if (this.complianceManager) {
        return this.complianceManager;
      } else if (this.medicalManager) {
        return this.medicalManager;
      } else if (this.directCareStaff) {
        return this.directCareStaff;
      } else if (this.assistantManager) {
        return this.assistantManager;
      } else if (this.houseManager) {
        return this.houseManager;
      } else if (this.humanResources) {
        return this.humanResources;
      }

      return false;
    },
    medCertified() {
      return this.user.MedCertified;
    },
  },

  mounted() {
    this.getUser();
  },
  created() {
    this.clientID = this.$route.params.clientID;
    this.userID = localStorage.getItem("userID");
    this.getUserInfo(this.userID);
    if (localStorage.getItem("userRole") === "Administration") {
      //this.hideNav(this.individuals, "Incident Reports");
      this.administration = true;

      if (localStorage.getItem("userState") === "Nevada") {
        this.hideNav(this.services, "Support Strategies");
        let radForm = { title: "RAD", icon: "medicine", name: "RAD" };
        this.individuals.push(radForm);
        let dorForm = { title: "DOR", icon: "medicine", name: "DOR" };
        this.individuals.push(dorForm);
        let habForm = { title: "HAB Plan", icon: "medicine", name: "HAB" };
        let habChart = { title: "HAB Plan Chart", icon: "medicine", name: "HABChart" };
        this.services.push(habForm, habChart);
        let dataTracking = {
          title: "Data Sheet",
          icon: "medicine",
          name: "DataTracking",
        };
        this.individuals.push(dataTracking);
        this.hideNav(this.individuals, "Incident Reports");
        let incidentReport = {
          title: "Incident Report",
          icon: "medicine",
          name: "NVIncidents",
        };
        this.individuals.push(incidentReport);
        // let bowelMovement = { title: "Bowel Movement", icon: "medicine", name: "BMC" };
        // this.services.push(bowelMovement)
        // let caseManagement = { title: "Case Management", icon: "medicine", name: "Case Management" };
        // this.services.push(caseManagement)
        // let ancillaryLog = { title: "Ancillary", icon: "medicine", name: "Ancillary" };
        // this.services.push(ancillaryLog)
        // let serviceLog = { title: "Service Log", icon: "medicine", name: "Service Log" };
        // this.services.push(serviceLog)


      }
    } else if (localStorage.getItem("userRole") === "Client") {
      this.client = true;
      (this.medications = [
        // { title: 'Medications', icon: 'medicine', route: '/medications'},
        { title: "MAR", icon: "medicine", name: "MAR" },
        // { title: 'Med visit', icon: 'medicine', route: '/medVisit'},
        // { title: 'Medication Inventory', icon: 'medicine', route: '/medicationInventory' }
      ]),
        (this.onboards = []);
      this.individuals = [
        { title: "Attendance", icon: "medicine", name: "Attendance" },
        // { title: "Investigations", icon: "medicine", name: "Investigations" },
        // { title: 'Human Rights Restrictions', icon: 'medicine', route: '/rights' },
        // { title: 'Providers', icon: 'medicine', route: '/providers' },
        { title: "Upcoming Events", icon: "medicine", name: "Events" },
        { title: "Inventory", icon: "medicine", name: "Inventory" },
        { title: "Finance", icon: "medicine", name: "Finances" },
        // { title: "Incident Reports", icon: "medicine", name: "Incidents" },
        // { title: 'Weekly Summary', icon: 'medicine', route: '/weeklySummary' },
        // { title: 'Monthly Summary', icon: 'medicine', route: '/MonthlySummaries' },
        // { title: 'Quarterly Summary', icon: 'medicine', name: 'QuarterlySummaries' },
        // { title: "Behavior Report", icon: "medicine", name: "BehaviorReport" },
      ];
      this.services = [
        // { title: 'Service Plan', icon: 'medicine', route: '/servicePlan' },
        { title: "ADL Charting", icon: "medicine", name: "ADL" },
        // { title: 'Support Strategies', icon: 'medicine', route: '/support' },
      ];
      if (localStorage.getItem("userState") === "Nevada") {
        let weeklySummary = {
          title: "Weekly Summary",
          icon: "medicine",
          name: "WeeklySummary",
        };
        this.individuals.push(weeklySummary);
        let quarterForm = {
          title: "Quarterly Summary",
          icon: "medicine",
          name: "QuarterlySummaries",
        };
        this.individuals.push(quarterForm);
        this.hideNav(this.services, "Support Strategies");
        this.hideNav(this.individuals, "Monthly Summary");
        this.hideNav(this.individuals, "Incident Reports");
        let dataTracking = {
          title: "Data Sheet",
          icon: "medicine",
          name: "DataTracking",
        };
        this.individuals.push(dataTracking);
        let incidentReport = {
          title: "Incident Report",
          icon: "medicine",
          name: "NVIncidents",
        };
        this.individuals.push(incidentReport);
      }
    } else if (localStorage.getItem("userRole") === "Direct Care Staff") {
      this.directCareStaff = true;

      this.medications = [
        // { title: 'Medications', icon: 'medicine', route: '/medications'},
        { title: "MAR", icon: "medicine", name: "MAR" },
        // { title: 'Med visit', icon: 'medicine', route: '/medVisit'},
        // { title: 'Medication Inventory', icon: 'medicine', route: '/medicationInventory' }
        {
          title: "Medication Change",
          icon: "medicine",
          name: "Medication Change",
        },
      ];

      if (this.medCertified) {
        this.medications.push(
          { title: "Medication Hand Off", icon: "medicine", name: "MedHandOff" },
          { title: "Medications", icon: "medicine", name: "Medications" }
        )
      }

      this.onboards = [
        { title: "Annual Documents", icon: "medicine", name: "AnnualDocs" },
      ];
      this.individuals = [
        { title: "Client Summary", icon: "medicine", name: "Client Summary" },
        { title: "Investigations", icon: "medicine", name: "Investigations" },
        // { title: 'Attendance', icon: 'medicine', route: '/attendance' },
        {
          title: "Human Rights Restrictions",
          icon: "medicine",
          name: "Rights",
        },
        // { title: 'Providers', icon: 'medicine', route: '/providers' },
        { title: "Upcoming Events", icon: "medicine", name: "Events" },
        { title: "Behavior Report", icon: "medicine", name: "BehaviorReport" },

        // { title: 'Inventory', icon: 'medicine', route: '/inventory' },
        // { title: 'Finance', icon: 'medicine', route: '/finances' },
        { title: "Incident Reports", icon: "medicine", name: "Incidents" },
        { title: "Weekly Summary", icon: "medicine", name: "WeeklySummary" },
        // { title: 'Quarterly Summary', icon: 'medicine', name: 'QuarterlySummaries' },
          {
          title: "Monthly Summary",
          icon: "medicine",
          name: "MonthlySummaries",
        },
      ];
      this.services = [
        // { title: 'Service Plan', icon: 'medicine', route: '/servicePlan' },
        { title: "ADL Charting", icon: "medicine", name: "ADL" },
        { title: "Bowel Movement", icon: "medicine", name: "BMC" },

        // { title: 'Support Strategies', icon: 'medicine', route: '/support' },
      ];
      if (localStorage.getItem("userState") === "Nevada") {
        this.hideNav(this.individuals, "Incident Reports");
        // this.hideNav(this.services, "Support Strategies");
        // this.hideNav(this.individuals, "Monthly Summary");
        let dorForm = { title: "DOR", icon: "medicine", name: "DOR" };
        this.individuals.push(dorForm);
        let radForm = { title: "RAD", icon: "medicine", name: "RAD" };
        this.individuals.push(radForm);
        let fluidTracking = { title: "Fluid Tracking", icon: "medicine", name: "FluidTracking" };
        this.services.push(fluidTracking);
        let habForm = { title: "HAB Plan", icon: "medicine", name: "HAB" };
        let habChart = { title: "HAB Plan Chart", icon: "medicine", name: "HABChart" };
        this.services.push(habForm, habChart);
        let dataTracking = {
          title: "Data Sheet",
          icon: "medicine",
          name: "DataTracking",
        };
        this.individuals.push(dataTracking);
        let incidentReport = {
          title: "Incident Report",
          icon: "medicine",
          name: "NVIncidents",
        };
        this.individuals.push(incidentReport);
      }
    } else if (localStorage.getItem("userRole") === "Shift Lead") {
      this.shiftLead = true;

      if(this.medCertified){
        this.medications.push({ title: "Medication Hand Off", icon: "medicine", name: "MedHandOff" },)
      }

      this.medications = [
        // { title: 'Medications', icon: 'medicine', route: '/medications'},
        { title: "MAR", icon: "medicine", name: "MAR" },
        { title: "Medical Visit Form", icon: "medicine", name: "MedVisit" },
        // { title: 'Medication Inventory', icon: 'medicine', route: '/medicationInventory' }
        {
          title: "Medication Change",
          icon: "medicine",
          name: "Medication Change",
        },
      ];
      this.individuals = [
        { title: "Client Summary", icon: "medicine", name: "Client Summary" },
        { title: "Investigations", icon: "medicine", name: "Investigations" },
        // { title: 'Attendance', icon: 'medicine', route: '/attendance' },
        {
          title: "Human Rights Restrictions",
          icon: "medicine",
          name: "Rights",
        },
        // { title: 'Providers', icon: 'medicine', route: '/providers' },
        { title: "Upcoming Events", icon: "medicine", name: "Events" },
        { title: "Behavior Report", icon: "medicine", name: "BehaviorReport" },

        { title: 'Inventory', icon: 'medicine', name: "Inventory" },
        { title: "Finance", icon: "medicine", name: "Finances" },
        { title: "Incident Reports", icon: "medicine", name: "Incidents" },
        { title: "Weekly Summary", icon: "medicine", name: "WeeklySummary" },
        { title: 'Quarterly Summary', icon: 'medicine', name: 'QuarterlySummaries' },

        //   {
        //   title: "Monthly Summary",
        //   icon: "medicine",
        //   name: "MonthlySummaries",
        // },
      ];
      this.services = [
        // { title: 'Service Plan', icon: 'medicine', route: '/servicePlan' },
        { title: "ADL Charting", icon: "medicine", name: "ADL" },
        { title: "Support Strategies", icon: "medicine", name: "Support" },
        { title: "Bowel Movement", icon: "medicine", name: "BMC" },


      ];
      if (localStorage.getItem("userState") === "Nevada") {
        this.hideNav(this.individuals, "Incident Reports");
        // this.hideNav(this.services, "Support Strategies");
        // this.hideNav(this.individuals, "Monthly Summary");
        let dorForm = { title: "DOR", icon: "medicine", name: "DOR" };
        this.individuals.push(dorForm);
        let radForm = { title: "RAD", icon: "medicine", name: "RAD" };
        this.individuals.push(radForm);
        let fluidTracking = { title: "Fluid Tracking", icon: "medicine", name: "FluidTracking" };
        this.services.push(fluidTracking);
        let habForm = { title: "HAB Plan", icon: "medicine", name: "HAB" };
        let habChart = { title: "HAB Plan Chart", icon: "medicine", name: "HABChart" };
        this.services.push(habForm, habChart);
        let quarterForm = {
          title: "Quarterly Summary",
          icon: "medicine",
          name: "QuarterlySummaries",
        };
        this.individuals.push(quarterForm);
        let dataTracking = {
          title: "Data Sheet",
          icon: "medicine",
          name: "DataTracking",
        };
        this.individuals.push(dataTracking);
        let incidentReport = {
          title: "Incident Report",
          icon: "medicine",
          name: "NVIncidents",
        };
        this.individuals.push(incidentReport);
      }
    } else if (localStorage.getItem("userRole") === "Assistant Manager") {
      this.assistantManager = true;
      this.medications = [
        // { title: 'Medications', icon: 'medicine', route: '/medications'},
        { title: "MAR", icon: "medicine", name: "MAR" },
        { title: "Medical Visit Form", icon: "medicine", name: "MedVisit" },
        // { title: 'Medication Inventory', icon: 'medicine', route: '/medicationInventory' },
        { title: "Medication Hand Off", icon: "medicine", name: "MedHandOff" },
        {
          title: "Medication Change",
          icon: "medicine",
          name: "Medication Change",
        },
      ];
      this.individuals = [
        { title: "Client Summary", icon: "medicine", name: "Client Summary" },
        // { title: "Investigations", icon: "medicine", name: "Investigations" },
        { title: "Attendance", icon: "medicine", name: "Attendance" },
        { title: 'Human Rights Restrictions', icon: 'medicine', route: '/rights' },
        // { title: 'Providers', icon: 'medicine', route: '/providers' },
        { title: "Upcoming Events", icon: "medicine", name: "Events" },
        { title: 'Inventory', icon: 'medicine', name: 'Inventory' },
        { title: "Finance", icon: "medicine", name: "Finances" },
        { title: "Incident Reports", icon: "medicine", name: "Incidents" },
        { title: "Weekly Summary", icon: "medicine", name: "WeeklySummary" },
        { title: "Quarterly Summary", icon: "medicine", name: "QuarterlySummaries" },
        // {
        //   title: "Monthly Summary",
        //   icon: "medicine",
        //   route: "/MonthlySummaries",
        // },
        { title: "Behavior Report", icon: "medicine", name: "BehaviorReport" },
        { title: "Fire Drill", icon: "medicine", name: "FireDrill" },
      ];
      this.services = [
        // { title: 'Service Plan', icon: 'medicine', route: '/servicePlan' },
        { title: "ADL Charting", icon: "medicine", name: "ADL" },
        { title: "Bowel Movement", icon: "medicine", name: "BMC" },

        // { title: 'Support Strategies', icon: 'medicine', route: '/support' },
      ];
      if (localStorage.getItem("userState") === "Nevada") {
        this.hideNav(this.individuals, "Incident Reports");
        this.hideNav(this.services, "Support Strategies");
        //this.hideNav(this.individuals, "Monthly Summary");
        let dorForm = { title: "DOR", icon: "medicine", name: "DOR" };
        this.individuals.push(dorForm);
        let radForm = { title: "RAD", icon: "medicine", name: "RAD" };
        this.individuals.push(radForm);
        let fluidTracking = { title: "Fluid Tracking", icon: "medicine", name: "FluidTracking" };
        this.services.push(fluidTracking);
        let mealForm = { title: "Menu", icon: "medicine", name: "Meals" };
        this.individuals.push(mealForm);
        let habForm = { title: "HAB Plan", icon: "medicine", name: "HAB" };
        this.services.push(habForm, this.nevadaService);
        let habChart = { title: "HAB Plan Chart", icon: "medicine", name: "HABChart" };
        this.services.push(habChart);
        let quarterForm = {
          title: "Quarterly Summary",
          icon: "medicine",
          name: "QuarterlySummaries",
        };
        this.individuals.push(quarterForm);
        let dataTracking = {
          title: "Data Sheet",
          icon: "medicine",
          name: "DataTracking",
        };
        this.individuals.push(dataTracking);
        let incidentReport = {
          title: "Incident Report",
          icon: "medicine",
          name: "NVIncidents",
        };
        this.individuals.push(incidentReport);
        let bowelMovement = { title: "Bowel Movement", icon: "medicine", name: "BMC" };
        this.services.push(bowelMovement)
      }
    } else if (localStorage.getItem("userRole") === "House Manager") {
      this.houseManager = true;
      this.medications = [
        // { title: 'Medications', icon: 'medicine', route: '/medications'},
        { title: "MAR", icon: "medicine", name: "MAR" },
        { title: "Medical Visit Form", icon: "medicine", name: "MedVisit" },
        // { title: 'Medication Inventory', icon: 'medicine', route: '/medicationInventory' },
        { title: "Medication Hand Off", icon: "medicine", name: "MedHandOff" },
        { title: "Medication Change", icon: "medicine", name: "MedChange" },
      ];
      this.individuals = [
        { title: "Client Summary", icon: "medicine", name: "Client Summary" },
        // { title: "Investigations", icon: "medicine", name: "Investigations" },
        { title: "Attendance", icon: "medicine", name: "Attendance" },
        {
          title: "Human Rights Restrictions",
          icon: "medicine",
          name: "Rights",
        },
        // { title: 'Providers', icon: 'medicine', route: '/providers' },
        { title: "Upcoming Events", icon: "medicine", name: "Events" },
        { title: "Inventory", icon: "medicine", name: "Inventory" },
        { title: "Finance", icon: "medicine", name: "Finances" },
        { title: "Incident Reports", icon: "medicine", name: "Incidents" },
        { title: "Fire Drill", icon: "medicine", name: "FireDrill" },
        { title: "Weekly Summary", icon: "medicine", name: "WeeklySummary" },
        // { title: "Quarterly Summary", icon: "medicine", name: "QuarterlySummaries" },
        {
          title: "Monthly Summary",
          icon: "medicine",
          name: "MonthlySummaries",
        },
        { title: "Behavior Report", icon: "medicine", name: "BehaviorReport" },
      ];
      this.services = [
        // { title: 'Service Plan', icon: 'medicine', route: '/servicePlan' },
        { title: "ADL Charting", icon: "medicine", name: "ADL" },
        { title: "Support Strategies", icon: "medicine", name: "Support" },
        { title: "Bowel Movement", icon: "medicine", name: "BMC" },

      ];
      if (localStorage.getItem("userState") === "Nevada") {
        this.hideNav(this.individuals, "Incident Reports");
        this.hideNav(this.services, "Support Strategies");
        //this.hideNav(this.individuals, "Monthly Summary");
        let dorForm = { title: "DOR", icon: "medicine", name: "DOR" };
        this.individuals.push(dorForm);
        let radForm = { title: "RAD", icon: "medicine", name: "RAD" };
        this.individuals.push(radForm);
        let fluidTracking = { title: "Fluid Tracking", icon: "medicine", name: "FluidTracking" };
        this.services.push(fluidTracking);
        let mealForm = { title: "Menu", icon: "medicine", name: "Meals" };
        this.individuals.push(mealForm);
        let habForm = { title: "HAB Plan", icon: "medicine", name: "HAB" };
        this.services.push(habForm, this.nevadaService);
        let habChart = { title: "HAB Plan Chart", icon: "medicine", name: "HABChart" };
        this.services.push(habChart);
        let quarterForm = {
          title: "Quarterly Summary",
          icon: "medicine",
          name: "QuarterlySummaries",
        };
        this.individuals.push(quarterForm);
        let dataTracking = {
          title: "Data Sheet",
          icon: "medicine",
          name: "DataTracking",
        };
        this.individuals.push(dataTracking);
        let incidentReport = {
          title: "Incident Report",
          icon: "medicine",
          name: "NVIncidents",
        };
        this.individuals.push(incidentReport);
        // let caseManagement = { title: "Case Management", icon: "medicine", name: "Case Management" };
        // this.services.push(caseManagement)
        // let ancillaryLog = { title: "Ancillary", icon: "medicine", name: "Ancillary" };
        // this.services.push(ancillaryLog)
        // let serviceLog = { title: "Service Log", icon: "medicine", name: "Service Log" };
        // this.services.push(serviceLog)

      }
    } else if (localStorage.getItem("userRole") === "Program Manager") {
      this.programManager = true;
      this.individuals = [
        { title: "Client Summary", icon: "medicine", name: "Client Summary" },
        // { title: "Investigations", icon: "medicine", name: "Investigations" },
        { title: "Attendance", icon: "medicine", name: "Attendance" },
        { title: "Behavior Report", icon: "medicine", name: "BehaviorReport" },
        {
          title: "Human Rights Restrictions",
          icon: "medicine",
          name: "Rights",
        },
        { title: "Providers", icon: "medicine", name: "Providers" },
        { title: "Upcoming Events", icon: "medicine", name: "Events" },
        { title: "Inventory", icon: "medicine", name: "Inventory" },
        { title: "Finance", icon: "medicine", name: "Finances" },
        { title: "Incident Reports", icon: "medicine", name: "Incidents" },
        { title: "Weekly Summary", icon: "medicine", name: "WeeklySummary" },
        // { title: "Quarterly Summary", icon: "medicine", name: "QuarterlySummaries" },
        {
          title: "Monthly Summary",
          icon: "medicine",
          name: "MonthlySummaries",
        },
        { title: "Fire Drill", icon: "medicine", name: "FireDrill" },
        { title: "Menu", icon: "medicine", name: "Meals" },
      ];
      this.medications = [
        // { title: 'Medications', icon: 'medicine', route: '/medications'},
        { title: "MAR", icon: "medicine", name: "MAR" },
        { title: "Medical Visit Form", icon: "medicine", name: "MedVisit" },
        // { title: 'Medication Inventory', icon: 'medicine', route: '/medicationInventory' },
        { title: "Medication Hand Off", icon: "medicine", name: "MedHandOff" },
        { title: "Medication Change", icon: "medicine", name: "MedChange" },
      ];
      this.services = [
        // { title: 'Service Plan', icon: 'medicine', route: '/servicePlan' },
        { title: "ADL Charting", icon: "medicine", name: "ADL" },
        { title: "Support Strategies", icon: "medicine", name: "Support" },
        { title: "Bowel Movement", icon: "medicine", name: "BMC" },

      ];

      if (localStorage.getItem("userState") === "Nevada") {
        this.hideNav(this.services, "Support Strategies");
        this.hideNav(this.individuals, "Incident Reports");
        let dorForm = { title: "DOR", icon: "medicine", name: "DOR" };
        this.individuals.push(dorForm);
        let radForm = { title: "RAD", icon: "medicine", name: "RAD" };
        this.individuals.push(radForm);
        let fluidTracking = { title: "Fluid Tracking", icon: "medicine", name: "FluidTracking" };
        this.services.push(fluidTracking);
        let habForm = { title: "HAB Plan", icon: "medicine", name: "HAB" };
        let habChart = { title: "HAB Plan Chart", icon: "medicine", name: "HABChart" };
        this.services.push(habForm, habChart);
        let quarterForm = {
          title: "Quarterly Summary",
          icon: "medicine",
          name: "QuarterlySummaries",
        };
        this.individuals.push(quarterForm);
        let dataTracking = {
          title: "Data Sheet",
          icon: "medicine",
          name: "DataTracking",
        };
        this.individuals.push(dataTracking);
        let incidentReport = {
          title: "Incident Report",
          icon: "medicine",
          name: "NVIncidents",
        };
        this.individuals.push(incidentReport);

        // let caseManagement = { title: "Case Management", icon: "medicine", name: "Case Management" };
        // this.services.push(caseManagement)
        // let ancillaryLog = { title: "Ancillary", icon: "medicine", name: "Ancillary" };
        // this.services.push(ancillaryLog)
        // let serviceLog = { title: "Service Log", icon: "medicine", name: "Service Log" };
        // this.services.push(serviceLog)
      }
    } else if (localStorage.getItem("userRole") === "Human Resources") {
      this.humanResources = true;
      if (localStorage.getItem("userState") === "Nevada") {
        this.hideNav(this.individuals, "Incident Reports");
        this.hideNav(this.services, "Support Strategies");
        this.hideNav(this.individuals, "Monthly Summary");
        let dorForm = { title: "DOR", icon: "medicine", name: "DOR" };
        this.individuals.push(dorForm);
        let radForm = { title: "RAD", icon: "medicine", name: "RAD" };
        this.individuals.push(radForm);
        let habForm = { title: "HAB Plan", icon: "medicine", name: "HAB" };
        let habChart = { title: "HAB Plan Chart", icon: "medicine", name: "HABChart" };
        this.services.push(habForm, habChart);
        let dataTracking = {
          title: "Data Sheet",
          icon: "medicine",
          name: "DataTracking",
        };
        this.individuals.push(dataTracking);
        let incidentReport = {
          title: "Incident Report",
          icon: "medicine",
          name: "NVIncidents",
        };
        this.individuals.push(incidentReport);
      }
    } else if (localStorage.getItem("userRole") === "Program Coordinator") {
      this.programCoordinator = true;
      if (localStorage.getItem("userState") === "Nevada") {
        this.hideNav(this.individuals, "Incident Reports");
        this.hideNav(this.services, "Support Strategies");
        //this.hideNav(this.individuals, "Monthly Summary");
        let dorForm = { title: "DOR", icon: "medicine", name: "DOR" };
        this.individuals.push(dorForm);
        let radForm = { title: "RAD", icon: "medicine", name: "RAD" };
        this.individuals.push(radForm);
        let habForm = { title: "HAB Plan", icon: "medicine", name: "HAB" };
        let habChart = { title: "HAB Plan Chart", icon: "medicine", name: "HABChart" };
        this.services.push(habForm, habChart);
        let dataTracking = {
          title: "Data Sheet",
          icon: "medicine",
          name: "DataTracking",
        };
        this.individuals.push(dataTracking);
        let incidentReport = {
          title: "Incident Report",
          icon: "medicine",
          name: "NVIncidents",
        };
        this.individuals.push(incidentReport);
        // let caseManagement = { title: "Case Management", icon: "medicine", name: "Case Management" };
        // this.services.push(caseManagement)
        // let ancillaryLog = { title: "Ancillary", icon: "medicine", name: "Ancillary" };
        // this.services.push(ancillaryLog)
        // let serviceLog = { title: "Service Log", icon: "medicine", name: "Service Log" };
        // this.services.push(serviceLog)
      }
    } else if (localStorage.getItem("userRole") === "Client Services Manager") {
      this.clientServicesManager = true;
      if (localStorage.getItem("userState") === "Nevada") {
        this.hideNav(this.individuals, "Incident Reports");
        this.hideNav(this.services, "Support Strategies");
        //this.hideNav(this.individuals, "Monthly Summary");
        let dorForm = { title: "DOR", icon: "medicine", name: "DOR" };
        this.individuals.push(dorForm);
        let radForm = { title: "RAD", icon: "medicine", name: "RAD" };
        this.individuals.push(radForm);
        let habForm = { title: "HAB Plan", icon: "medicine", name: "HAB" };
        let habChart = { title: "HAB Plan Chart", icon: "medicine", name: "HABChart" };
        this.services.push(habForm, habChart);
        let dataTracking = {
          title: "Data Sheet",
          icon: "medicine",
          name: "DataTracking",
        };
        this.individuals.push(dataTracking);
        let incidentReport = {
          title: "Incident Report",
          icon: "medicine",
          name: "NVIncidents",
        };
        this.individuals.push(incidentReport);
        // let caseManagement = { title: "Case Management", icon: "medicine", name: "Case Management" };
        // this.services.push(caseManagement)
        // let ancillaryLog = { title: "Ancillary", icon: "medicine", name: "Ancillary" };
        // this.services.push(ancillaryLog)
        // let serviceLog = { title: "Service Log", icon: "medicine", name: "Service Log" };
        // this.services.push(serviceLog)
      }
    } else if (localStorage.getItem("userRole") === "Medical Manager") {
      this.medicalManager = true;
      if (localStorage.getItem("userState") === "Nevada") {
        this.hideNav(this.individuals, "Incident Reports");
        this.hideNav(this.services, "Support Strategies");
        let dorForm = { title: "DOR", icon: "medicine", name: "DOR" };
        this.individuals.push(dorForm);
        let radForm = { title: "RAD", icon: "medicine", name: "RAD" };
        this.individuals.push(radForm);
        let habForm = { title: "HAB Plan", icon: "medicine", name: "HAB" };
        let habChart = { title: "HAB Plan Chart", icon: "medicine", name: "HABChart" };
        this.services.push(habForm, habChart);
        let dataTracking = {
          title: "Data Sheet",
          icon: "medicine",
          name: "DataTracking",
        };
        this.individuals.push(dataTracking);
        let incidentReport = {
          title: "Incident Report",
          icon: "medicine",
          name: "NVIncidents",
        };
        this.individuals.push(incidentReport);
        // let caseManagement = { title: "Case Management", icon: "medicine", name: "Case Management" };
        // this.services.push(caseManagement)
        // let ancillaryLog = { title: "Ancillary", icon: "medicine", name: "Ancillary" };
        // this.services.push(ancillaryLog)
        // let serviceLog = { title: "Service Log", icon: "medicine", name: "Service Log" };
        // this.services.push(serviceLog)
      }
    } else if (localStorage.getItem("userRole") === "Executive Director") {
      this.executiveDirector = true;
      if (localStorage.getItem("userState") === "Nevada") {
        this.hideNav(this.individuals, "Incident Reports");
        this.hideNav(this.services, "Support Strategies");
        //this.hideNav(this.individuals, "Monthly Summary");
        let dorForm = { title: "DOR", icon: "medicine", name: "DOR" };
        this.individuals.push(dorForm);
        let radForm = { title: "RAD", icon: "medicine", name: "RAD" };
        this.individuals.push(radForm);
        let habForm = { title: "HAB Plan", icon: "medicine", name: "HAB" };
        let habChart = { title: "HAB Plan Chart", icon: "medicine", name: "HABChart" };
        this.services.push(habForm, habChart);
        let dataTracking = {
          title: "Data Sheet",
          icon: "medicine",
          name: "DataTracking",
        };
        this.individuals.push(dataTracking);
        let incidentReport = {
          title: "Incident Report",
          icon: "medicine",
          name: "NVIncidents",
        };
        this.individuals.push(incidentReport);
        // let caseManagement = { title: "Case Management", icon: "medicine", name: "Case Management" };
        // this.services.push(caseManagement)
        // let ancillaryLog = { title: "Ancillary", icon: "medicine", name: "Ancillary" };
        // this.services.push(ancillaryLog)
        // let serviceLog = { title: "Service Log", icon: "medicine", name: "Service Log" };
        // this.services.push(serviceLog)
      }
    } else if (localStorage.getItem("userRole") === "Regional Director") {
      this.executiveDirector = true;
      if (localStorage.getItem("userState") === "Nevada") {
        this.hideNav(this.individuals, "Incident Reports");
        this.hideNav(this.services, "Support Strategies");
        //this.hideNav(this.individuals, "Monthly Summary");
        let dorForm = { title: "DOR", icon: "medicine", name: "DOR" };
        this.individuals.push(dorForm);
        let radForm = { title: "RAD", icon: "medicine", name: "RAD" };
        this.individuals.push(radForm);
        let habForm = { title: "HAB Plan", icon: "medicine", name: "HAB" };
        let habChart = { title: "HAB Plan Chart", icon: "medicine", name: "HABChart" };
        this.services.push(habForm, habChart);
        let dataTracking = {
          title: "Data Sheet",
          icon: "medicine",
          name: "DataTracking",
        };
        this.individuals.push(dataTracking);
        let incidentReport = {
          title: "Incident Report",
          icon: "medicine",
          name: "NVIncidents",
        };
        this.individuals.push(incidentReport);
        // let caseManagement = { title: "Case Management", icon: "medicine", name: "Case Management" };
        // this.services.push(caseManagement)
        // let ancillaryLog = { title: "Ancillary", icon: "medicine", name: "Ancillary" };
        // this.services.push(ancillaryLog)
        // let serviceLog = { title: "Service Log", icon: "medicine", name: "Service Log" };
        // this.services.push(serviceLog)
      }
    } else if (localStorage.getItem("userRole") === "Finance Manager") {
      this.financeManager = true;
      if (localStorage.getItem("userState") === "Nevada") {
        this.hideNav(this.individuals, "Incident Reports");
        this.hideNav(this.services, "Support Strategies");
        //this.hideNav(this.individuals, "Monthly Summary");
        let dorForm = { title: "DOR", icon: "medicine", name: "DOR" };
        this.individuals.push(dorForm);
        let radForm = { title: "RAD", icon: "medicine", name: "RAD" };
        this.individuals.push(radForm);
        let habForm = { title: "HAB Plan", icon: "medicine", name: "HAB" };
        let habChart = { title: "HAB Plan Chart", icon: "medicine", name: "HABChart" };
        this.services.push(habForm, habChart);
        let dataTracking = {
          title: "Data Sheet",
          icon: "medicine",
          name: "DataTracking",
        };
        this.individuals.push(dataTracking);
        let incidentReport = {
          title: "Incident Report",
          icon: "medicine",
          name: "NVIncidents",
        };
        this.individuals.push(incidentReport);
        let bowelMovement = { title: "Bowel Movement", icon: "medicine", name: "BMC" };
        this.services.push(bowelMovement)
        // let caseManagement = { title: "Case Management", icon: "medicine", name: "Case Management" };
        // this.services.push(caseManagement)
        // let ancillaryLog = { title: "Ancillary", icon: "medicine", name: "Ancillary" };
        // this.services.push(ancillaryLog)
        // let serviceLog = { title: "Service Log", icon: "medicine", name: "Service Log" };
        // this.services.push(serviceLog)
      }
    } else if (localStorage.getItem("userRole") === "Compliance Manager") {
      this.complianceManager = true;
      if (localStorage.getItem("userState") === "Nevada") {
        this.hideNav(this.individuals, "Incident Reports");
        this.hideNav(this.services, "Support Strategies");
        //this.hideNav(this.individuals, "Monthly Summary");
        let dorForm = { title: "DOR", icon: "medicine", name: "DOR" };
        this.individuals.push(dorForm);
        let radForm = { title: "RAD", icon: "medicine", name: "RAD" };
        this.individuals.push(radForm);
        let habForm = { title: "HAB Plan", icon: "medicine", name: "HAB" };
        let habChart = { title: "HAB Plan Chart", icon: "medicine", name: "HABChart" };
        this.services.push(habForm, habChart);
        let dataTracking = {
          title: "Data Sheet",
          icon: "medicine",
          name: "DataTracking",
        };
        this.individuals.push(dataTracking);
        let incidentReport = {
          title: "Incident Report",
          icon: "medicine",
          name: "NVIncidents",
        };
        this.individuals.push(incidentReport);
        // let caseManagement = { title: "Case Management", icon: "medicine", name: "Case Management" };
        // this.services.push(caseManagement)
        // let ancillaryLog = { title: "Ancillary", icon: "medicine", name: "Ancillary" };
        // this.services.push(ancillaryLog)
        // let serviceLog = { title: "Service Log", icon: "medicine", name: "Service Log" };
        // this.services.push(serviceLog)
      }
    } else if (localStorage.getItem("userRole") === "Parent/Guardian") {
      this.parentGuardian = true;
    } else if (localStorage.getItem("userRole") === "Support Coordinator") {
      this.supportCoordinator = true;
      // this.medApproved = false;
      // this.guardian = true;
    } else if (localStorage.getItem("userRole") === "Pharmacy") {
      this.medications = [
        { title: "Medications", icon: "medicine", name: "Medications" },
        // { title: "MAR", icon: "medicine", name: "MAR" },
        // { title: 'Med visit', icon: 'medicine', name: '/medVisit'},
        {
          title: "Medication Inventory",
          icon: "medicine",
          name: "MedicationInventory",
        },
      ];
      this.onboards = [];
      this.services = [];
      this.documents = [];
      this.individuals = [];
    }
    // else if( localStorage.getItem('userRole')=="Client"){
    //   console.log(this.client);
    //   this.client = true;
    // }
  },
  methods: {
    ...mapActions("users", ["getUser"]),
    getUserInfo: function(id) {
      axios.get(`${url}/users/${id}`).then((res) => {
        this.userName = res.data.user.Name;
        this.profileimg = res.data.user.Image;
      });
    },

    hideNav(navItem, title) {
      //navItem.splice(navItem.findIndex((item) => item.title === title));
      let index = navItem.findIndex((item) => item.title === title);
      navItem.splice(index, 1);
      //alert(index);
    },
  },
};
</script>
<style>
.back-button {
  color: white !important;
}

@media only screen and (max-width: 600px) {
  .v-menu.mobile {
    display: none;
  }
}
@media only screen and (max-width: 480px) {
  .v-menu.desktop {
    display: none;
  }
}
</style>
